//Margin conventions
var margin = {top: 0, right: 128, bottom: 22, left: 28};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 320 - margin.top - margin.bottom;

//Parses date for correct time format
var parseDate = d3.time.format("%Y").parse;  

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
	.attr("width", width + margin.left + margin.right)
	.attr("height", height + margin.top + margin.bottom)
	.append("g")
	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.time.scale()
  .range([0, width]);

//Creates the yScale
var yScale = d3.scale.linear()
  .range([height, 0]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
	.scale(yScale)
  .tickSize(-width)
  .tickPadding(6)
  .ticks(6)
  .tickFormat(function(d) { return "$" + d/1000000000; })
	.orient("left");

//Defines the y axis styles
var xAxis = d3.svg.axis()
	.scale(xScale)
  .tickPadding(6)
	.orient("bottom")
  .ticks(2)
  .tickFormat(d3.time.format("%Y")); 

//line function convention (feeds an array)
var line = d3.svg.line()
  .x(function(d) { return xScale(d.year); })
  .y(function(d) { return yScale(d.dollar); }); 

//Loads the data
d3.csv("data/snacks.csv", ready);

function ready(err, data) {

	if (err) throw "error loading data";

	//FORMAT data
	data.forEach(function(d) {
		d.dollar = +d.dollar;
    d.year = parseDate(d.year);
	});
	
	//Organizes the data	
  var maxY = d3.max(data, function(d) { return d.dollar; });
  var maxX = d3.max(data, function(d) { return d.year; });

  //Nest the data
  var dataByCategory = d3.nest()
    .key(function(d) { return d.type;})
    .entries(data);

  console.log(dataByCategory);  

  //Defines the xScale max
  xScale.domain(d3.extent(data, function(d) { return d.year; }));

  //Defines the yScale max
  yScale.domain([0, maxY + 5000000000]);

	//Appends the y axis
	var yAxisGroup = svg.append("g")
		.attr("class", "y axis")
		.call(yAxis)
		.selectAll("g")
		.classed("g-baseline", function(d) {return d == 0});

	//Appends the x axis		
	var xAxisGroup = svg.append("g")
		.attr("class", "x axis")
		.attr("transform", "translate(0," + height + ")")
		.call(xAxis);   

  //Binds the data to the line
  var drawline = svg.selectAll(".cat-path")
    .data(dataByCategory)
    .enter()
    .append("path")
    .attr("class", "cat-path")
    .attr("d", function(d) { return line(d.values) })
    .classed("Cookies-line", function(d) { return d.key == "Cookies"; })
    .classed("Crackers-line", function(d) { return d.key == "Crackers"; })
    .classed("Bars-line", function(d) { return d.key == "Snack bars/granola bars"; })
    .classed("Gum-line", function(d) { return d.key == "Gum"; }) 
    .classed("Chocolate-line", function(d) { return d.key == "Chocolate candy"; })
    .classed("Nonchoc-line", function(d) { return d.key == "Non-chocolate candy"; })
    .classed("Salty-line", function(d) { return d.key == "Salty snacks"; }); 

  //Append labels  
  var Cookieslabel = svg.append("text")
      .text("Cookies")
      .attr("class", "Cookies-label")
      .attr("x", width/1)
      .attr("y", height/1.47)
      .attr("transform", "translate(5,0)");   

  var Crackerslabel = svg.append("text")
      .text("Crackers")
      .attr("class", "Crackers-label")
      .attr("x", width/1)
      .attr("y", height/1.3)
      .attr("transform", "translate(5,0)");    

  var Barslabel = svg.append("text")
      .text("Snack bars/")
      .attr("class", "Bars-label")
      .attr("x", width/1)
      .attr("y", height/1.22)
      .attr("transform", "translate(5,0)");

  var Barslabel2 = svg.append("text")
            .text("granola bars")
            .attr("class", "Bars-label")
            .attr("x", width/1)
            .attr("y", height/1.165)
            .attr("transform", "translate(5,0)");

  var Gumlabel = svg.append("text")
      .text("Gum")
      .attr("class", "Gum-label")
      .attr("x", width/1)
      .attr("y", height/1.08)
      .attr("transform", "translate(5,0)");  

  var Chocolatelabel = svg.append("text")
      .text("Chocolate candy")
      .attr("class", "Chocolate-label")
      .attr("x", width/1)
      .attr("y", height/2)
      .attr("transform", "translate(5,0)");

  var Nonchoclabel = svg.append("text")
      .text("Non-chocolate candy")
      .attr("class", "Nonchoc-label")
      .attr("x", width/1)
      .attr("y", height/1.38)
      .attr("transform", "translate(5,0)");   

  var Saltylabel = svg.append("text")
      .text("Salty snacks")
      .attr("class", "Salty-label")
      .attr("x", width/1)
      .attr("y", height/5.2)
      .attr("transform", "translate(5,0)");                         	

//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 0, right: 128, bottom: 22, left: 28};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the line
    line = d3.svg.line()
      .x(function(d) { return xScale(d.year); })
      .y(function(d) { return yScale(d.dollar); }); 

    d3.selectAll('.cat-path')
      .attr("d", function(d) { return line(d.values) }) 

    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(2);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);

    Cookieslabel
      .attr("x", newWidth/1);  

    Crackerslabel
      .attr("x", newWidth/1); 

    Barslabel
      .attr("x", newWidth/1); 

    Barslabel2
      .attr("x", newWidth/1);  

    Chocolatelabel
      .attr("x", newWidth/1);     

    Nonchoclabel
      .attr("x", newWidth/1); 

    Gumlabel
      .attr("x", newWidth/1); 

    Saltylabel
      .attr("x", newWidth/1);         
  };

}